
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-background",
      function () {
        return require("private-next-pages/ai-background/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-background"])
      });
    }
  